import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';

export default function Merci() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, ok: false, amount: 0, donorName: '' });

  useEffect(() => {
    const sid = params.get('session_id');
    if (!sid) { setState({ loading: false, ok: false, amount: 0, donorName: '' }); return; }
    axios.get('/api/donations/confirm?session_id=' + encodeURIComponent(sid))
      .then(r => setState({ loading: false, ok: !!r.data.ok, amount: r.data.amount || 0, donorName: r.data.donorName || '' }))
      .catch(() => setState({ loading: false, ok: false, amount: 0, donorName: '' }));
  }, []);

  const wrap = { minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', background: '#faf7f5' };
  const card = { background: '#fff', borderRadius: '16px', padding: '40px 32px', maxWidth: '440px', width: '100%', textAlign: 'center', boxShadow: '0 12px 40px rgba(0,0,0,0.08)' };
  const homeBtn = { display: 'inline-block', background: '#8b1a2a', color: '#fff', textDecoration: 'none', borderRadius: '8px', padding: '12px 28px', fontSize: '14px', fontWeight: '600' };

  if (state.loading) return (
    <div style={wrap}><div style={card}><div style={{ fontSize: '14px', color: '#6a5050' }}>Vérification de votre paiement…</div></div></div>
  );

  if (state.ok) return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: '46px', marginBottom: '12px', color: '#8b1a2a' }}>♥</div>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: '24px', color: '#1a1010', margin: '0 0 12px' }}>Merci{state.donorName && state.donorName !== 'Anonyme' ? ', ' + state.donorName : ''} !</h1>
        <p style={{ fontSize: '14px', color: '#6a5050', lineHeight: '1.7', margin: '0 0 8px' }}>Votre don de <strong>{state.amount} €</strong> a bien été reçu.</p>
        <p style={{ fontSize: '13px', color: '#9a8080', lineHeight: '1.7', margin: '0 0 24px' }}>Grâce à vous, ce site reste gratuit et sans publicité. Du fond du cœur, merci pour votre soutien.</p>
        <Link to="/" style={homeBtn}>Retour à l'accueil</Link>
      </div>
    </div>
  );

  return (
    <div style={wrap}>
      <div style={card}>
        <div style={{ fontSize: '40px', marginBottom: '12px', color: '#c0b0b0' }}>♥</div>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#1a1010', margin: '0 0 12px' }}>Paiement non confirmé</h1>
        <p style={{ fontSize: '14px', color: '#6a5050', lineHeight: '1.7', margin: '0 0 24px' }}>Le paiement n'a pas pu être confirmé, ou il a été annulé. Aucun montant n'a été débité si vous n'avez pas finalisé le don.</p>
        <Link to="/" style={homeBtn}>Retour à l'accueil</Link>
      </div>
    </div>
  );
}
